var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWformg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.75 33.75H38.25V38.25H24.75V33.75ZM20.25 15.75H15.75V20.25H20.25V15.75ZM24.75 29.25H38.25V24.75H24.75V29.25ZM24.75 20.25H38.25V15.75H24.75V20.25ZM20.25 24.75H15.75V29.25H20.25V24.75ZM47.25 11.25V42.75C47.25 45.225 45.225 47.25 42.75 47.25H11.25C8.775 47.25 6.75 45.225 6.75 42.75V11.25C6.75 8.775 8.775 6.75 11.25 6.75H42.75C45.225 6.75 47.25 8.775 47.25 11.25ZM42.75 11.25H11.25V42.75H42.75V11.25ZM20.25 33.75H15.75V38.25H20.25V33.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWformg1);
export default __webpack_public_path__ + "static/media/wformg1.91e6cece18d0ae0f94f1ad44a2a09273.svg";
export { ForwardRef as ReactComponent };